document.addEventListener('DOMContentLoaded', () => {
	const button = document.querySelector('.ob-mobile-country-flag');
	// eslint-disable-next-line no-undef
	button.addEventListener('click', () => _transcy.methods.onShowOrHideSwitcher(this));
});